import baseStyles from '../Base/Base.styles';
import {propertiesToJss as titleJss} from '../BaseTitle/BaseTitle.styles';
import {responsiveTextAlignment} from '../Base/responsiveAlignment';

export default ({title, base}) => {
  let jss = {
    root: {
      ...baseStyles(base),
      '&': {display: 'block'},
      '& .text': {
        ...titleJss(title || {}),
        ...responsiveTextAlignment(base.alignment),
      },
    },
  };

  return jss;
};
